'use strict';

var _tslib = require('../../../_virtual/_tslib.js');
var jsxRuntime = require('react/jsx-runtime');
var tailwindMerge = require('tailwind-merge');
require('../../DataDisplays/Avatar/Avatar.js');
require('../../Base/Layouts/Box/Box.js');
require('../../Base/Layouts/FullBleed/FullBleed.js');
require('../../DataDisplays/Label/Label.js');
var ProductIcon = require('../../DataDisplays/ProductIcon/ProductIcon.js');
require('../../DataDisplays/SystemIcon/Icons/Medium/MediumBell.js');
var Checkbox = require('../Checkbox/Checkbox.js');

const CheckboxCardContainer = (_a)=>{
    var { children, isWide, checked, isError, disabled, className } = _a, rest = _tslib.__rest(_a, [
        "children",
        "isWide",
        "checked",
        "isError",
        "disabled",
        "className"
    ]);
    const generateBorderStyles = ()=>{
        const CHECKED_NON_ERROR = checked && !isError;
        if (disabled) return tailwindMerge.twMerge('cursor-not-allowed', CHECKED_NON_ERROR ? 'border-primary-100' : 'border-w-gray-200');
        if (isError) return 'border-w-red-500';
        if (checked) return 'border-primary-500';
        return 'border-w-gray-200 group-hover:border-primary';
    };
    const generateBackgroundStyles = ()=>{
        const CHECKED_NON_ERROR = checked && !isError;
        if (disabled) return CHECKED_NON_ERROR ? 'bg-primary-10' : 'bg-w-gray-10';
        if (checked) return isError ? 'bg-w-red-10' : 'bg-primary-10';
        return 'bg-w-white';
    };
    return jsxRuntime.jsx("div", Object.assign({
        className: tailwindMerge.twMerge('relative flex h-auto cursor-pointer items-center gap-2 rounded-xl border', isWide ? 'min-h-[94px] w-[298px] flex-row gap-3 px-5 py-4' : 'min-h-fit w-[224px] flex-col justify-center px-4 pb-6 pt-4', generateBorderStyles(), generateBackgroundStyles(), className)
    }, rest, {
        children: children
    }));
};
const TitleContainer = ({ isWide, children })=>{
    return jsxRuntime.jsx("div", {
        className: tailwindMerge.twMerge('flex h-auto w-full flex-col justify-between gap-0.5', isWide ? 'items-start' : 'items-center'),
        children: children
    });
};
const StyledCheckbox = (_a)=>{
    var { isWide, className } = _a, rest = _tslib.__rest(_a, [
        "isWide",
        "className"
    ]);
    const isNormal = !isWide;
    return jsxRuntime.jsx(Checkbox, Object.assign({
        className: tailwindMerge.twMerge(isNormal && 'absolute left-[17px] top-[17px] group-hover:border-primary-500', className)
    }, rest));
};
const CheckboxCardIcon = ({ iconName, disabled, checked, isError })=>{
    const isIconDisabled = isError || !checked;
    return jsxRuntime.jsx("div", {
        className: tailwindMerge.twMerge('flex size-[60px] flex-shrink-0 items-center justify-center', disabled && 'opacity-30'),
        "data-testid": "design-system-checkboxCard--icon",
        children: jsxRuntime.jsx(ProductIcon, {
            name: iconName,
            disabled: isIconDisabled
        })
    });
};

exports.CheckboxCardContainer = CheckboxCardContainer;
exports.CheckboxCardIcon = CheckboxCardIcon;
exports.StyledCheckbox = StyledCheckbox;
exports.TitleContainer = TitleContainer;
